import { Button, Headline3, Meta, theme } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';
import { ColumnWithMargins } from 'styles/ContainerStyles';

interface VehicleSelectPermissionProps {
  handleContinue: () => void;
  handleCancel: () => void;
}

const DescriptionContainer = styled.View<{ pb?: number }>`
  margin-top: 20px;
`;

const TitleDescriptionContainer = styled.View`
  align-items: center;
  margin-bottom: 20px;
`;

const ButtonContainer = styled.View`
  margin-top: 10px;
`;

export const VehicleSelectPermission: React.FC<
  VehicleSelectPermissionProps
> = ({ handleContinue, handleCancel }) => {
  const { t } = useTranslation();

  return (
    <ColumnWithMargins>
      <TitleDescriptionContainer>
        <Headline3>
          {t('account.automaticVehicleSelect.addLicensePlate')}
        </Headline3>
        <DescriptionContainer>
          <Meta color={theme.colors.gray300}>
            {t('account.terms.licensePlateReadingPermission')}
          </Meta>
        </DescriptionContainer>
      </TitleDescriptionContainer>
      <Button
        size="l"
        onPress={handleContinue}
        text={t('button.addLicensePlate')}
        testID="continue-permission-button"
      />
      <ButtonContainer>
        <Button
          size="l"
          onPress={handleCancel}
          text={t('button.cancel')}
          testID="continue-permission-button"
          buttonType="tertiary"
        />
      </ButtonContainer>
    </ColumnWithMargins>
  );
};
